export const PUBLIC_MENU = 'public-menu'

export const USER_MENU = 'user-menu'

export const PRIVATE_MENU = 'private-menu'

export const PRIVATE_CALENDAR_MENU = 'private-calendar-menu'

export const PRIVATE_COTTAGES_MENU = 'private-cottages-menu'

export const PRIVATE_SERVICES_MENU = 'private-services-menu'

export const PRIVATE_ONLINE_BOOKING_CONFIG_MENU =
  'private-online-booking-config-menu'

export const FOOTER_MENU = 'footer-menu'

export const FOOTER_SOCIAL_MENU = 'footer-social-menu'

export const FOOTER_APPS_MENU = 'footer-apps-menu'

export type MENU_TYPE =
  | typeof USER_MENU
  | typeof PUBLIC_MENU
  | typeof PRIVATE_MENU
  | typeof PRIVATE_CALENDAR_MENU
  | typeof PRIVATE_COTTAGES_MENU
  | typeof PRIVATE_SERVICES_MENU
  | typeof PRIVATE_ONLINE_BOOKING_CONFIG_MENU
  | typeof FOOTER_MENU
  | typeof FOOTER_SOCIAL_MENU
  | typeof FOOTER_APPS_MENU
